import React from "react";
import * as Shared from "../components/CivicShared";

const {
  api, copy, subCategories, wardPath, VIJAYANAGAR_WARDS, CIVIC_CATEGORIES, CIVIC_CATEGORIES_KN,
  Gate, SectionHeading, CivicStat, MiniAction, InfoCard, SimplePage, LocationPickerMap, Modal, FeedbackBox, NotFound,
  AlertCircle, ArrowLeft, ArrowRight, Bell, BriefcaseBusiness, Building2, Check, CheckCircle2, ChevronDown, Clock3,
  Eye, EyeOff, FileText, Globe2, HeartHandshake, Home, Lightbulb, LockKeyhole, LogIn, LogOut, Mail, MapPin, Menu,
  MessageCircle, MessageSquare, Phone, Search, ShieldCheck, Smartphone, UserCircle, UserRound, Users, X, MapContainer,
  TileLayer, useMapEvents
} = Shared;

export default function HomePage({
  lang, setLang, user, setUser, dashboard, mobile, setMobile, setOpenMenu, openMenu, go, logout, t, modal, setModal
}) {
  return (
    <div className="civic-site" lang={lang === "kn" ? "kn" : "en"}>
      <header className="civic-header">
        <div className="civic-header-inner">

          <button className="civic-brand brand-button" onClick={() => go("/")}>
            <span className="civic-logo">V</span>
            <span className="civic-brand-text">
              <strong>Vijayanagar</strong>
              <small>Civic Portal</small>
            </span>
          </button>

          <nav className={mobile ? "civic-nav open" : "civic-nav"}>

  {/* 1. HOME */}
  <button
    className="nav-link"
    onClick={() => {
      go("/");
      setOpenMenu("");
      setMobile(false);
    }}
  >
    {t.home}
  </button>

  {/* 2. ABOUT */}
  <button
    className="nav-link"
    onClick={() => {
      go("/author");
      setOpenMenu("");
      setMobile(false);
    }}
  >
    About
  </button>

  {/* 3. REPORT ISSUE + TRACK COMPLAINT */}
  <div className="nav-dropdown">
    <button
      className="nav-report dropdown-trigger"
      onClick={(e) => {
        e.stopPropagation();
        setOpenMenu(openMenu === "report" ? "" : "report");
      }}
      aria-expanded={openMenu === "report"}
    >
      <FileText size={16} />
      <span>Report Issue</span>
      <ChevronDown size={15} />
    </button>

    <div
      className={
        openMenu === "report"
          ? "dropdown-menu show"
          : "dropdown-menu"
      }
    >
      <button
        onClick={() => {
          setModal("report");
          setOpenMenu("");
          setMobile(false);
        }}
      >
        <FileText size={15} />
        Report an Issue
      </button>

      <button
        onClick={() => {
          setModal("track");
          setOpenMenu("");
          setMobile(false);
        }}
      >
        <Search size={15} />
        Track Complaint
      </button>

      {user && (
        <button
          onClick={() => {
            go("/reports");
            setOpenMenu("");
            setMobile(false);
          }}
        >
          <FileText size={15} />
          My Reports
        </button>
      )}
    </div>
  </div>

  {/* 4. EXPLORE */}
  <div className="nav-dropdown">
    <button
      className="nav-link dropdown-trigger"
      onClick={(e) => {
        e.stopPropagation();
        setOpenMenu(openMenu === "explore" ? "" : "explore");
      }}
      aria-expanded={openMenu === "explore"}
    >
      <span>Explore</span>
      <ChevronDown size={15} />
    </button>

    <div
      className={
        openMenu === "explore"
          ? "dropdown-menu show"
          : "dropdown-menu"
      }
    >
      <button
        onClick={() => {
          go("/wards");
          setOpenMenu("");
          setMobile(false);
        }}
      >
        <MapPin size={15} />
        Explore Wards
      </button>

      <button
        onClick={() => {
          go("/dashboard");
          setOpenMenu("");
          setMobile(false);
        }}
      >
        <ShieldCheck size={15} />
        Civic Dashboard
      </button>

      <button
        onClick={() => {
          go("/services");
          setOpenMenu("");
          setMobile(false);
        }}
      >
        <Building2 size={15} />
        Public Services
      </button>
    </div>
  </div>

  {/* 5. COMMUNITY */}
  <div className="nav-dropdown">
    <button
      className="nav-link dropdown-trigger"
      onClick={(e) => {
        e.stopPropagation();
        setOpenMenu(openMenu === "community" ? "" : "community");
      }}
      aria-expanded={openMenu === "community"}
    >
      <span>Community</span>
      <ChevronDown size={15} />
    </button>

    <div
      className={
        openMenu === "community"
          ? "dropdown-menu show"
          : "dropdown-menu"
      }
    >
      <button
        onClick={() => {
          go("/community");
          setOpenMenu("");
          setMobile(false);
        }}
      >
        <MessageSquare size={15} />
        Community
      </button>

      <button
        onClick={() => {
          go("/volunteer");
          setOpenMenu("");
          setMobile(false);
        }}
      >
        <Users size={15} />
        Volunteer
      </button>

      <button
        onClick={() => {
          go("/jobs");
          setOpenMenu("");
          setMobile(false);
        }}
      >
        <BriefcaseBusiness size={15} />
        Jobs
      </button>
    </div>
  </div>

  {/* 6. CONTACT */}
  <button
    className="nav-link"
    onClick={() => {
      go("/contact");
      setOpenMenu("");
      setMobile(false);
    }}
  >
    Contact
  </button>

  {/* MOBILE ADMIN */}
  {(user?.role === "admin" || user?.role === "staff") && (
    <button
      className="nav-link mobile-admin-link"
      onClick={() => {
        go("/admin");
        setOpenMenu("");
        setMobile(false);
      }}
    >
      <ShieldCheck size={16} />
      Admin Panel
    </button>
  )}

</nav>

          <div className="civic-header-actions">

            <button
              className="language-btn"
              onClick={() => setLang(lang === "en" ? "kn" : "en")}
              aria-label={lang === "en" ? "Switch to Kannada" : "Switch to English"}
            >
              <Globe2 size={15} />
              <span>{lang === "en" ? "ಕನ್ನಡ" : "English"}</span>
            </button>

            {user ? (
              <>
                <button
                  className="header-profile"
                  onClick={() => go("/profile")}
                >
                  <UserCircle size={16} />
                  <span>{t.profile}</span>
                </button>

                {(user.role === "admin" || user.role === "staff") && (
                  <button
                    className="header-admin"
                    onClick={() => go("/admin")}
                  >
                    Admin
                  </button>
                )}

                <button
                  className="header-icon"
                  onClick={logout}
                  title={t.logout}
                  aria-label={t.logout}
                >
                  <LogOut size={17} />
                </button>
              </>
            ) : (
              <button className="login-btn" onClick={() => setModal("login")}>
                <LogIn size={16} />
                <span>{t.login}</span>
              </button>
            )}

            <button
              className="mobile-toggle"
              onClick={() => {
                setMobile(!mobile);
                setOpenMenu("");
              }}
              aria-label="Menu"
            >
              {mobile ? <X /> : <Menu />}
            </button>

          </div>
        </div>
      </header>

      <main>
        <section className="civic-hero">
          <div className="hero-inner">
            <div className="hero-content">
              <div className="civic-badge">
                <MapPin size={15} />
                Vijayanagar Civic Complaints
              </div>

              <h1>Vijayanagar Civic Complaints & Local Issues</h1>

              <p>
                Report Civic Complaints in Vijayanagar, Bengaluru, track complaint progress, explore local wards and access public civic information.
              </p>

              <div className="hero-buttons">
                <button
                  className="civic-btn primary large"
                  onClick={() => setModal("report")}
                >
                  <FileText size={18} />
                  {t.reportNow}
                  <ArrowRight size={17} />
                </button>

                <button
                  className="civic-btn secondary large"
                  onClick={() => setModal("track")}
                >
                  <Search size={18} />
                  {t.trackNow}
                </button>
              </div>

              <div className="hero-links">
                <button onClick={() => go("/wards")}>
                  {t.exploreWard} <ArrowRight size={15} />
                </button>

                <button onClick={() => go("/dashboard")}>
                  {t.dashboardBtn} <ArrowRight size={15} />
                </button>
              </div>
            </div>

            <div className="hero-panel">
              <div className="hero-panel-top">
                <span>13</span>
                <div>
                  <strong>Wards</strong>
                  <small>Vijayanagar Assembly</small>
                </div>
              </div>

              <div className="hero-mini-grid">
                <MiniAction icon={<FileText />} title={t.report} onClick={() => setModal("report")} />
                <MiniAction icon={<Search />} title={t.track} onClick={() => setModal("track")} />
                <MiniAction icon={<MapPin />} title={t.wards} onClick={() => go("/wards")} />
                <MiniAction icon={<ShieldCheck />} title={t.dashboard} onClick={() => go("/dashboard")} />
              </div>
            </div>
          </div>
        </section>

        <section className="stats-section">
          <div className="content-width">
            <div className="stats-grid">
              <CivicStat icon={<FileText />} value={dashboard?.stats?.reported ?? 0} label={t.reported} />
              <CivicStat icon={<Clock3 />} value={dashboard?.stats?.in_progress ?? 0} label={t.progress} />
              <CivicStat icon={<CheckCircle2 />} value={dashboard?.stats?.resolved ?? 0} label={t.resolved} />
              <CivicStat icon={<Building2 />} value={dashboard?.stats?.services ?? 24} label={t.servicesCount} />
            </div>
          </div>
        </section>

        <section className="civic-intro-section">
          <div className="content-width civic-intro-grid">
            <div className="civic-intro-copy">
              <span className="eyebrow">A DIGITAL CIVIC SERVICE</span>
              <h2>Report and Track Civic Issues in Vijayanagar, Bengaluru</h2>
              <p>
                Vijayanagar.org is designed to make it easier for residents
                across the Vijayanagar Assembly area to raise civic issues,
                provide useful details, follow complaint progress and access
                ward-level public information.
              </p>

              <div className="civic-intro-points">
                <div>
                  <CheckCircle2 size={18} />
                  <span>Submit complaints with location and photo evidence.</span>
                </div>
                <div>
                  <CheckCircle2 size={18} />
                  <span>Track complaints using a unique tracking ID.</span>
                </div>
                <div>
                  <CheckCircle2 size={18} />
                  <span>View public civic activity and ward information.</span>
                </div>
              </div>
            </div>

            <div className="civic-live-card">
              <span className="eyebrow">LIVE CIVIC ACTIVITY</span>
              <h3>Public activity at a glance</h3>
              <p>
                The figures below are connected to the civic service database
                and update as residents submit and staff process complaints.
              </p>

              <div className="live-mini-stats">
                <div>
                  <strong>{dashboard?.stats?.reported ?? 0}</strong>
                  <span>Reported</span>
                </div>
                <div>
                  <strong>{dashboard?.stats?.in_progress ?? 0}</strong>
                  <span>In Progress</span>
                </div>
                <div>
                  <strong>{dashboard?.stats?.resolved ?? 0}</strong>
                  <span>Resolved</span>
                </div>
              </div>

              <button className="text-link" onClick={() => go("/dashboard")}>
                View public dashboard <ArrowRight size={15} />
              </button>
            </div>
          </div>
        </section>

        <section className="how-section">
          <div className="content-width">
            <SectionHeading
              title="How the Vijayanagar Civic Portal Works"
              text="A simple digital process for residents to raise an issue and follow what happens next."
            />

            <div className="steps-grid">
              <article className="step-card">
                <div className="step-top">
                  <span>01</span>
                  <FileText size={23} />
                </div>
                <h3>Report an issue</h3>
                <p>
                  Choose the category and sub-category, select your ward,
                  describe the problem and optionally add location and photos.
                </p>
              </article>

              <article className="step-card">
                <div className="step-top">
                  <span>02</span>
                  <Search size={23} />
                </div>
                <h3>Track your complaint</h3>
                <p>
                  Every submitted complaint receives a tracking ID that can
                  be used to check its current status and timeline.
                </p>
              </article>

              <article className="step-card">
                <div className="step-top">
                  <span>03</span>
                  <CheckCircle2 size={23} />
                </div>
                <h3>Follow the progress</h3>
                <p>
                  Residents can see status updates and provide feedback after
                  an issue is marked resolved.
                </p>
              </article>
            </div>
          </div>
        </section>

        <section className="activity-section">
          <div className="content-width activity-grid">
            <div>
              <SectionHeading
                title="Recent civic activity"
                text="Publicly visible complaint activity from the civic service platform."
              />

              <div className="activity-list">
                {(dashboard?.complaints || []).slice(0, 6).map((item) => (
                  <div className="activity-item" key={item.tracking_id}>
                    <div className="activity-icon">
                      <FileText size={17} />
                    </div>
                    <div>
                      <strong>{item.title}</strong>
                      <span>
                        {item.category} · {item.ward}
                      </span>
                    </div>
                    <b>{item.status}</b>
                  </div>
                ))}

                {(!dashboard?.complaints || dashboard.complaints.length === 0) && (
                  <div className="activity-empty">
                    <FileText size={22} />
                    <strong>No public complaints yet</strong>
                    <span>
                      New civic complaints will appear here as they are submitted.
                    </span>
                  </div>
                )}
              </div>
            </div>

            <div className="activity-events">
              <span className="eyebrow">COMMUNITY ACTIVITY</span>
              <h3>Local civic information</h3>

              {(dashboard?.events || []).slice(0, 5).map((event, index) => (
                <div className="event-item" key={`${event.title}-${index}`}>
                  <div className="event-date">{event.date}</div>
                  <div>
                    <strong>{event.title}</strong>
                    <span>{event.place}</span>
                  </div>
                </div>
              ))}

              {(!dashboard?.events || dashboard.events.length === 0) && (
                <p className="activity-muted">
                  Civic events and public information will appear here.
                </p>
              )}
            </div>
          </div>
        </section>

        <section className="seo-content-section" aria-labelledby="vijayanagar-civic-help-heading">
          <div className="content-width">
            <span className="eyebrow">VIJAYANAGAR CIVIC INFORMATION</span>
            <h2 id="vijayanagar-civic-help-heading">Vijayanagar civic complaints, services and local issues</h2>
            <p>
              Vijayanagar.org helps residents in Vijayanagar, Bengaluru find civic information and report local problems through one digital civic portal. Residents can report issues such as roads and potholes, drainage, water supply, garbage and waste, street lights, sanitation, parks and public spaces, schools, health services, traffic and parking, stray animals and encroachment.
            </p>
            <div className="seo-link-grid">
              <a href="/complaints" onClick={(e) => { e.preventDefault(); go("/complaints"); }}>Vijayanagar complaints and civic issues</a>
              <a href="/report-issue" onClick={(e) => { e.preventDefault(); setModal("report"); }}>Report a civic complaint in Vijayanagar</a>
              <a href="/track-complaint" onClick={(e) => { e.preventDefault(); setModal("track"); }}>Track a Vijayanagar complaint</a>
              <a href="/wards" onClick={(e) => { e.preventDefault(); go("/wards"); }}>Explore Vijayanagar wards</a>
              <a href="/services" onClick={(e) => { e.preventDefault(); go("/services"); }}>Find Vijayanagar public services</a>
              <a href="/dashboard" onClick={(e) => { e.preventDefault(); go("/dashboard"); }}>View the civic dashboard</a>
              <a href="/community" onClick={(e) => { e.preventDefault(); go("/community"); }}>Explore the Vijayanagar community</a>
            </div>
          </div>
        </section>

        <section className="initiative-section">
          <div className="content-width initiative-grid">
            <div className="initiative-image-wrap">
              <img
                src="/images/author-portrait.webp"
                alt="SM Shailesh"
                loading="lazy"
              />
            </div>

            <div className="initiative-copy">
              <span className="eyebrow">ABOUT THIS INITIATIVE</span>
              <h2>Vijayanagar.org is carried out by SM Shailesh.</h2>
              <p>
                Vijayanagar.org is a self-initiated civic service platform
                carried out by <strong>SM Shailesh</strong> to provide residents
                with a convenient digital way to report civic issues, follow
                complaint progress and access public ward information.
              </p>
              <p>
                SM Shailesh has been involved in community and social-service
                activities, including helping residents access medicines,
                medical guidance, health assistance, government welfare
                schemes and subsidised banking support.
              </p>

              <div className="initiative-note">
                <ShieldCheck size={19} />
                <span>
                  The portal is intended to provide civic information and
                  complaint-management services for residents.
                </span>
              </div>

              <button
                className="civic-btn primary"
                onClick={() => go("/author")}
              >
                About SM Shailesh
                <ArrowRight size={17} />
              </button>
            </div>
          </div>
        </section>

        <section className="wards-section">
          <div className="content-width">
            <SectionHeading
              title="13 Wards · One Civic Complaint Platform"
              text="Explore local issues, ward information and civic activity."
            />

            <div className="ward-grid">
              {VIJAYANAGAR_WARDS.map((ward) => (
                <button
                  key={ward.number}
                  className="ward-card"
                  onClick={() => go(wardPath(ward))}
                >
                  <span className="ward-number">Ward {ward.number}</span>
                  <strong>{ward.name}</strong>
                  <ArrowRight size={17} />
                </button>
              ))}
            </div>
          </div>
        </section>

        <section className="categories-section">
          <div className="content-width">
            <SectionHeading
              title="What can you report?"
              text="Roads, water, waste, lighting, drainage, parks, schools, health, traffic and more."
            />

            <div className="category-grid">
              {(lang === "en" ? CIVIC_CATEGORIES : CIVIC_CATEGORIES_KN).map(
                (category, index) => (
                  <button
                    className="category-card"
                    key={category}
                    onClick={() => setModal("report")}
                  >
                    <span>{String(index + 1).padStart(2, "0")}</span>
                    <strong>{category}</strong>
                    <ArrowRight size={16} />
                  </button>
                )
              )}
            </div>
          </div>
        </section>

        <section className="public-dashboard-section">
          <div className="content-width dashboard-callout">
            <div>
              <span className="eyebrow">PUBLIC CIVIC INFORMATION</span>
              <h2>Civic Dashboard</h2>
              <p>
                See ward activity, complaint status and public civic information.
              </p>
            </div>

            <button className="civic-btn primary large" onClick={() => go("/dashboard")}>
              {t.dashboardBtn}
              <ArrowRight size={17} />
            </button>
          </div>
        </section>

        <section className="service-community-section">
          <div className="content-width two-column-cards">
            <InfoCard
              icon={<Building2 />}
              title="Civic Services"
              text="Find useful local services and public information."
              button={t.services}
              onClick={() => go("/services")}
            />

            <InfoCard
              icon={<MessageSquare />}
              title="Community Suggestions"
              text="Share a civic suggestion after signing in."
              button={t.community}
              onClick={() => go("/community")}
            />
          </div>
        </section>
      </main>

      <footer className="civic-footer">
        <div className="content-width footer-inner">
          <div>
            <div className="civic-brand footer-brand">
              <span className="civic-logo">V</span>
              <span>vijayanagar<span>.org</span></span>
            </div>
            <p>Vijayanagar Civic Connect</p>
          </div>

          <div className="footer-links">
            <button onClick={() => setModal("report")}>{t.report}</button>
            <button onClick={() => setModal("track")}>{t.track}</button>
            <button onClick={() => go("/wards")}>{t.wards}</button>
            <button onClick={() => go("/dashboard")}>{t.dashboard}</button>
            <button onClick={() => go("/services")}>{t.services}</button>
          </div>
        </div>
      </footer>

      {modal && (
        <Modal
          type={modal}
          user={user}
          setUser={setUser}
          close={() => setModal(null)}
          t={t}
          lang={lang}
        />
      )}
    </div>
  );
}
